import React, { useState } from 'react'
import { Modal, Table } from 'antd'
import { useFetchSubmissionsSummaryQuery } from '../../../../../../store/apis/submission.api'
import SubmissionsSummaryModalFooter from './SubmissionsSummaryModalFooter'
export const SUBMISSIONS_SUMMARY_PAGE_SIZE = 10

const SubmissionsSummaryModal = ({
    showSubmissionsSummaryModal,
    setShowSubmissionsSummaryModal,
    token,
    assignmentName,
}) => {
    const [page, setPage] = useState(1)

    const { data: submissionsSummary, isFetching: isFetchingSubmissionsSummary } = useFetchSubmissionsSummaryQuery({
        token,
        page,
    })

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Feedback URL',
            dataIndex: 'feedbackURL',
            key: 'feedbackURL',
            render: text => <a href={text}>{text}</a>,
        },
        {
            title: 'Grade',
            dataIndex: 'grade',
            key: 'grade',
        },
    ]

    const data = []

    submissionsSummary?.submissions.map((file, index) => {
        data.push({
            key: file.name + index,
            name: file.name,
            feedbackURL: file.instantFeedbackUrl,
            grade: file.grade,
        })
    })

    return (
        <Modal
            open={showSubmissionsSummaryModal}
            title={`${assignmentName}'s submissions summary`}
            onCancel={() => setShowSubmissionsSummaryModal(false)}
            width='70%'
            centered
            bodyStyle={{ maxHeight: '80vh' }}
            footer={[<SubmissionsSummaryModalFooter key='footer' assignmentName={assignmentName} token={token} />]}
        >
            <div style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                <Table
                    columns={columns}
                    dataSource={data}
                    loading={isFetchingSubmissionsSummary}
                    pagination={{
                        onChange: page => setPage(page),
                        current: page,
                        pageSize: SUBMISSIONS_SUMMARY_PAGE_SIZE,
                        total: SUBMISSIONS_SUMMARY_PAGE_SIZE * submissionsSummary?.totalPages,
                        itemRender: (item, type, element) => {
                            let ariaLabel
                            if (type === 'page') {
                                ariaLabel = `${type} ${item}`
                            } else {
                                ariaLabel = `${type} page'`
                            }
                            return React.cloneElement(element, {
                                'aria-label': ariaLabel,
                            })
                        },
                    }}
                />
            </div>
        </Modal>
    )
}

export default SubmissionsSummaryModal
